/* @flow */
import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import * as types from 'redux/modules/main-menu/action-types';
import { openMenu, closeMenu } from 'redux/modules/main-menu/index';
import { Authenticated, NotAuthenticated, LogoutLink } from 'interactive-solutions/authentication';
import Translate from 'react-translate-component';
import Close from '../../../components/svg/close';
import Menu from '../../../components/svg/menu';

export class RightSection extends React.Component {

  static propTypes = {
    openMenu: PropTypes.func.isRequired,
    closeMenu: PropTypes.func.isRequired
  };

  render () {
    return (

      <div className='right-section'>

        <NotAuthenticated>
          <Link to='/login' className='login hide-tablet'><Translate content='LOGIN'/></Link>
          <Link to='/register' className='btn outlined create-account hide-tablet'>
            <Translate content='CREATE_ACCOUNT'/>
          </Link>
        </NotAuthenticated>

        <Authenticated>
          <LogoutLink classes='logout hide-tablet'><Translate content='LOGOUT'/></LogoutLink>
          <Link to='/invoice-tool' className='btn outlined create-invoice hide-tablet'>
            <Translate content='CREATE_INVOICE'/>
          </Link>
        </Authenticated>

        <button className='menu-btn open-menu' onClick={this.props.openMenu}>
          <span className='menu-btn-svg'><Menu color="#FFFFFF" /></span>
          <span className='menu-btn-text hide-tablet'><Translate content='MENU'/></span>
        </button>

        <button className='menu-btn close-menu' onClick={this.props.closeMenu}>
          <span className='menu-btn-svg'><Close color="#FFFFFF" /></span>
          <span className='menu-btn-text hide-tablet'><Translate content='CLOSE'/></span>
        </button>
      </div>
    );
  }
}

function mapStateToProps (state) {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    openMenu: () => {
      dispatch(openMenu({
        action: {
          type: types.OPEN_MAIN_MENU
        }
      }));
    },
    closeMenu: () => {
      dispatch(closeMenu({
        action: {
          type: types.CLOSE_MAIN_MENU
        }
      }));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RightSection);



/** WEBPACK FOOTER **
 ** ./src/components/header/right-section/right-section.js
 **/